import { z } from 'zod';
import { isMongoId } from '../../helpers';

export const Create = z
  .object({
    firmName: z.string().min(1, 'Please enter firm name.'),
    addCurrentUserToOrganization: z.boolean(),
    newUserAuth0RoleId: z.string().optional(),
  })
  .refine(
    (data) =>
      !(
        data.addCurrentUserToOrganization &&
        (!data.newUserAuth0RoleId || data.newUserAuth0RoleId.trim() === '')
      ),
    {
      path: ['newUserAuth0RoleId'],
      message: 'Please select a role for the user.',
    },
  );

export const Update = z.object({
  id: z.string().refine(isMongoId()),
  firmName: z.string().min(1, 'Please enter firm name.'),
  keyContactEmails: z.array(
    z.string().email('Please enter a valid email address.'),
  ),
  systemDateFormat: z
    .string()
    .min(1, 'Please enter system date format.')
    .optional(),
  timezone: z.string().min(1, 'Please enter timezone.').optional(),
  subscriptionFlowEmailRecipients: z.array(
    z.string().email('Please enter a valid email address.'),
  ),
  verifiedReplyToEmailAddress: z
    .union([
      z.string().email('Please enter a valid email address.'),
      z.literal(''),
    ])
    .optional(),
  contactEmail: z
    .union([
      z.string().email('Please enter a valid email address.'),
      z.literal(''),
    ])
    .optional(),
  contactPhoneNumber: z.string().optional(),
  contactHours: z.string().optional(),
  portalSubdomain: z.string().optional(),
  lightMainLogo: z.string().optional(),
  darkMainLogo: z.string().optional(),
  panelColor: z.string().optional(),
  secondaryColor: z.string().optional(),
  highlightColor: z.string().optional(),
  squareLogo: z.string().optional(),
  portalFooterText: z.string().optional(),
  emailFooterText: z.string().optional(),
});
